import {
  Box,
  Button,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { CircleDollarSign } from 'lucide-react';
import { PRICE_RANGE_OPTIONS } from '~/apps/consumer/components/MapSearch/Filters/constants';
import { RangeCreatableSelectInput } from '~/apps/consumer/components/RangeCreatableSelectInput/RangeCreatableSelectInput';

interface PriceRangeFilterProps {
  minValue: number | undefined;
  maxValue: number | undefined;
  setMinValue: (value: number | undefined) => void;
  setMaxValue: (value: number | undefined) => void;
}

export const PriceRangeFilter = ({
  minValue,
  maxValue,
  setMinValue,
  setMaxValue,
}: PriceRangeFilterProps) => {
  const formatPrice = (value?: number) => {
    if (!value) return '';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const buttonText =
    minValue || maxValue
      ? `${formatPrice(minValue) || 'No min'} - ${
          formatPrice(maxValue) || 'No max'
        }`
      : 'All prices';

  return (
    <Popover placement="bottom-start">
      <PopoverTrigger>
        <Button height="42px" pl={3} pr={4} size="sm" variant="input">
          <Icon
            as={CircleDollarSign}
            color="whiteAlpha.500"
            display="inline-block"
            height="18px"
            mr={2}
            verticalAlign="middle"
            width="18px"
          />
          {buttonText}
        </Button>
      </PopoverTrigger>
      <PopoverContent p={4} width="350px">
        <Box>
          <RangeCreatableSelectInput
            initialMaxValue={maxValue}
            initialMinValue={minValue}
            label="Price Range"
            options={PRICE_RANGE_OPTIONS}
            onChangeMax={(value) => setMaxValue(value)}
            onChangeMin={(value) => setMinValue(value)}
          />
        </Box>
      </PopoverContent>
    </Popover>
  );
};
